module.exports = __webpack_public_path__ + "static/media/Adobe Express - file.d700bf36.png";